import PropTypes from 'prop-types';

export const HomeCheckerShape = {
  firstName: PropTypes.string.isRequired,
  photoUrl: PropTypes.string.isRequired
};

export default { HomeCheckerShape };
